(function () {
  'use strict';

  function init() {
    var root = document.getElementById('mt-ss');
    if (!root || root.dataset.mtInit === '1') return;
    root.dataset.mtInit = '1';

    var isProduct = root.dataset.context === 'product';
    var staffel = [];
    try { staffel = JSON.parse(root.dataset.staffel || '[]'); } catch (e) {}
    staffel.sort(function (a, b) { return a.min - b.min; });

    var elKeuze = document.getElementById('mt-ss-keuze');
    var elTotaal = document.getElementById('mt-ss-totaal');
    var elLever = document.getElementById('mt-ss-lever');
    var elLeverTekst = document.getElementById('mt-ss-levertekst');
    var elBtn = document.getElementById('mt-ss-btn');
    var elBtnTekst = document.getElementById('mt-ss-btntekst');
    var elFout = document.getElementById('mt-ss-fout');
    var elFoto = document.getElementById('mt-ss-foto');
    var elTitel = document.getElementById('mt-ss-titel');
    var elPreview = document.getElementById('mt-ss-preview');
    var elPreviewAnker = document.getElementById('mt-ss-previewanker');
    var elStaffel = document.getElementById('mt-ss-staffel');
    var elStaffelBody = document.getElementById('mt-ss-staffelbody');
    var elAantal = document.getElementById('mt-ss-aantal');
    var mobiel = window.matchMedia('(max-width: 989px)');

    var lightbox = document.getElementById('mt-ss-lightbox');
    var lightboxImg = document.getElementById('mt-ss-lightbox-img');
    if (lightbox && lightbox.parentElement !== document.body) document.body.appendChild(lightbox);

    var actiefPaneel = null, fotos = {}, gekozen = { zitting: null, poot: null };

    function euro(centen) { return '\u20AC\u00A0' + (centen / 100).toFixed(2).replace('.', ','); }
    function aantal() { var n = parseInt(elAantal.value, 10); return (isNaN(n) || n < 1) ? 1 : n; }

    function zetPreview(url, titel) {
      if (url) { elFoto.src = url; elFoto.alt = titel || ''; }
      if (titel) elTitel.textContent = titel;
    }

    function plaatsPreview() {
      if (!elPreview) return;
      if (mobiel.matches && actiefPaneel) {
        var g = actiefPaneel.querySelector('.mt-ss__grid--poot');
        if (g && g.nextElementSibling !== elPreview) g.insertAdjacentElement('afterend', elPreview);
      } else if (!mobiel.matches && elPreviewAnker && elPreviewAnker.nextElementSibling !== elPreview) {
        elPreviewAnker.insertAdjacentElement('afterend', elPreview);
      }
    }
    if (mobiel.addEventListener) mobiel.addEventListener('change', plaatsPreview);

    function openLightbox(url) {
      if (!lightbox || !url) return;
      lightboxImg.src = url;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function sluitLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    function kiesModel(kaart) {
      root.querySelectorAll('.mt-ss__model').forEach(function (k) { k.classList.toggle('is-active', k === kaart); });
      toonPaneel(kaart.dataset.paneel);
    }

    function toonPaneel(id) {
      actiefPaneel = null;
      root.querySelectorAll('.mt-ss__paneel').forEach(function (p) {
        p.hidden = p.dataset.paneel !== id;
        if (p.dataset.paneel === id) actiefPaneel = p;
      });
      if (!actiefPaneel) return;
      fotos = {};
      var mapEl = actiefPaneel.querySelector('.mt-ss__fotomap');
      if (mapEl) { try { fotos = JSON.parse(mapEl.textContent); } catch (e) {} }
      actiefPaneel.querySelectorAll('.mt-ss__card').forEach(function (c) { c.classList.remove('is-active'); });
      gekozen = { zitting: null, poot: null };
      zetPreview(actiefPaneel.dataset.foto, actiefPaneel.dataset.titel + ' \u00B7 kies zitting en onderstel');
      plaatsPreview();
      update();
    }

    root.addEventListener('click', function (e) {
      var zoom = e.target.closest('[data-zoom]');
      if (zoom) {
        e.preventDefault(); e.stopPropagation();
        var host = zoom.dataset.groot ? zoom : zoom.closest('[data-groot]');
        if (host && host.dataset.groot) openLightbox(host.dataset.groot);
        return;
      }
      var model = e.target.closest('.mt-ss__model');
      if (model) { kiesModel(model); return; }
      var kaart = e.target.closest('.mt-ss__card');
      if (kaart && actiefPaneel && actiefPaneel.contains(kaart)) {
        var type = kaart.dataset.type;
        actiefPaneel.querySelectorAll('.mt-ss__card[data-type="' + type + '"]').forEach(function (k) { k.classList.remove('is-active'); });
        kaart.classList.add('is-active');
        gekozen[type] = kaart;
        elFout.hidden = true;
        update();
      }
    });

    var previewKnop = document.getElementById('mt-ss-previewknop');
    if (previewKnop) previewKnop.addEventListener('click', function () { if (elFoto.src) openLightbox(elFoto.src); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-lightbox-sluit]') || e.target.id === 'mt-ss-lightbox') sluitLightbox();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lightbox && !lightbox.hidden) sluitLightbox(); });

    /* Levertijd (alleen op de pagina zichtbaar) */
    function toonLevertijd(z, p) {
      if (!elLever) return;
      var beide = z.dataset.voorraad === '1' && p.dataset.voorraad === '1';
      if (beide) {
        /* Traagste bezorgmethode bepaalt (data-rang 1 = PostNL, 2 = Max/XXL, 3 = Starfurn-75) */
        var traag = (parseInt(z.dataset.rang, 10) || 3) >= (parseInt(p.dataset.rang, 10) || 3) ? z : p;
        elLeverTekst.textContent = 'Op voorraad \u00B7 ' + (traag.dataset.snel || 'Gratis bezorgd binnen 7 werkdagen');
        elLever.classList.remove('is-later');
        return;
      }
      var uit = [];
      if (z.dataset.voorraad === '0') uit.push(z);
      if (p.dataset.voorraad === '0') uit.push(p);
      var traagste = uit[0];
      for (var i = 1; i < uit.length; i++) {
        if ((uit[i].dataset.levertijd || '').length > (traagste.dataset.levertijd || '').length) traagste = uit[i];
      }
      var wat = uit.length === 2 ? 'Zitting en onderstel zijn niet op voorraad'
        : (traagste.dataset.type === 'zitting' ? 'Deze zitting is niet op voorraad' : 'Dit onderstel is niet op voorraad');
      elLeverTekst.textContent = wat + ' \u00B7 ' + (traagste.dataset.levertijd || 'Gratis bezorgd binnen 2 werkdagen') + ' \u00B7 wordt compleet bezorgd';
      elLever.classList.add('is-later');
    }

    /* Staffeltabel */
    function tekenStaffel(stukprijs, qty) {
      if (!elStaffel || !stukprijs) { if (elStaffel) elStaffel.hidden = true; return; }
      elStaffel.hidden = false;
      var rijen = [{ min: 1, pct: 0 }].concat(staffel);
      var actiefMin = 1;
      for (var i = 0; i < rijen.length; i++) { if (qty >= rijen[i].min) actiefMin = rijen[i].min; }
      var html = '';
      rijen.forEach(function (r) {
        var perStoel = Math.round(stukprijs * (1 - r.pct / 100));
        var totaalVol = stukprijs * r.min;
        var totaal = perStoel * r.min;
        var totaalCel = r.pct > 0
          ? '<s>' + euro(totaalVol) + '</s><span class="mt-ss__actie">' + euro(totaal) + '</span>'
          : euro(totaal);
        html += '<tr class="' + (r.min === actiefMin ? 'is-actief' : '') + '">' +
          '<td>' + r.min + ' stuks</td>' +
          '<td>' + (r.pct ? r.pct + '%' : '\u2013') + '</td>' +
          '<td>' + euro(perStoel) + '</td>' +
          '<td>' + totaalCel + '</td></tr>';
      });
      elStaffelBody.innerHTML = html;
    }

    function update() {
      if (!actiefPaneel) return;
      var z = gekozen.zitting, p = gekozen.poot, titel = actiefPaneel.dataset.titel, qty = aantal();
      if (z && p) toonLevertijd(z, p);
      else if (elLever) { elLeverTekst.textContent = 'Op voorraad \u00B7 Gratis bezorgd binnen 2 werkdagen'; elLever.classList.remove('is-later'); }

      var stukprijs = 0;
      if (z && p) stukprijs = parseInt(z.dataset.prijs, 10) + parseInt(p.dataset.prijs, 10);
      else stukprijs = parseInt(actiefPaneel.dataset.vanaf, 10) || 0;
      tekenStaffel(stukprijs, qty);

      if (!z || !p) {
        elKeuze.textContent = (!z && !p) ? 'Kies een zitting en een onderstel' : (!z ? 'Kies nog een zitting' : 'Kies nog een onderstel');
        elTotaal.textContent = '';
        elBtn.disabled = true;
        if (z && !p) {
          var eerstePoot = actiefPaneel.querySelector('.mt-ss__card[data-type="poot"]');
          if (eerstePoot) {
            var voorbeeld = fotos[z.dataset.sku + '|' + eerstePoot.dataset.sku];
            zetPreview(voorbeeld || actiefPaneel.dataset.foto, titel + ' \u00B7 ' + z.dataset.naam + ' \u00B7 kies nog een onderstel');
          }
        }
        return;
      }

      var pct = 0;
      for (var si = 0; si < staffel.length; si++) { if (qty >= staffel[si].min) pct = staffel[si].pct; }
      var volTotaal = stukprijs * qty;
      var totaal = Math.round(stukprijs * (1 - pct / 100)) * qty;
      if (pct > 0) {
        elTotaal.innerHTML = '<s>' + euro(volTotaal) + '</s>' + euro(totaal) + '<span class="mt-ss__totaal-korting">' + pct + '% staffelkorting</span>';
      } else {
        elTotaal.textContent = euro(totaal);
      }
      elKeuze.textContent = titel + ' \u00B7 ' + z.dataset.naam + ' \u00B7 ' + p.dataset.naam + (qty > 1 ? ' \u00B7 ' + qty + ' stuks' : '');
      var combi = fotos[z.dataset.sku + '|' + p.dataset.sku];
      zetPreview(combi || actiefPaneel.dataset.foto, titel + ' \u00B7 ' + z.dataset.naam + ' \u00B7 ' + p.dataset.naam);
      elBtn.disabled = false;
    }

    /* Aantal */
    document.getElementById('mt-ss-min').addEventListener('click', function () { elAantal.value = Math.max(1, aantal() - 1); update(); });
    document.getElementById('mt-ss-plus').addEventListener('click', function () { elAantal.value = aantal() + 1; update(); });
    elAantal.addEventListener('input', update);

    /* Winkelwagen */
    elBtn.addEventListener('click', function () {
      var z = gekozen.zitting, p = gekozen.poot;
      if (!z || !p || !actiefPaneel) return;
      var qty = aantal();
      var setId = 'set-' + Date.now().toString(36);
      var oms = actiefPaneel.dataset.titel + ' \u2013 ' + z.dataset.naam + ' zitting + ' + p.dataset.naam + ' onderstel';

      elBtn.disabled = true;
      if (elBtnTekst) elBtnTekst.textContent = 'Bezig met toevoegen...';
      elFout.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(z.dataset.id, 10), quantity: qty, properties: { '_set': setId, '_onderdeel': 'zitting', 'Samengestelde stoel': oms } },
            { id: parseInt(p.dataset.id, 10), quantity: qty, properties: { '_set': setId, '_onderdeel': 'onderstel', 'Samengestelde stoel': oms } }
          ]
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          if (elBtnTekst) elBtnTekst.textContent = 'Toegevoegd aan winkelwagen';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(function () { window.location.href = '/cart'; }, 500);
        })
        .catch(function () {
          elBtn.disabled = false;
          if (elBtnTekst) elBtnTekst.textContent = 'Voeg toe aan winkelwagen';
          elFout.hidden = false;
          elFout.textContent = 'Het toevoegen is niet gelukt. Probeer het opnieuw of neem contact met ons op.';
        });
    });

    var eersteModel = root.querySelector('.mt-ss__model');
    if (eersteModel) kiesModel(eersteModel);
    else { var pnl = root.querySelector('.mt-ss__paneel'); if (pnl) toonPaneel(pnl.dataset.paneel); }

    /* Voorselectie onderstel via ?poot=SKU (link vanaf een los onderstel dat alleen in set verkocht wordt) */
    try {
      var pootSku = new URLSearchParams(window.location.search).get('poot');
      if (pootSku) {
        pootSku = pootSku.replace(/[^A-Za-z0-9_-]/g, '');
        var pk = root.querySelector('.mt-ss__card[data-type="poot"][data-sku="' + pootSku + '"]');
        if (pk) {
          var pkPaneel = pk.closest('.mt-ss__paneel');
          if (pkPaneel && pkPaneel !== actiefPaneel) {
            var pkModel = root.querySelector('.mt-ss__model[data-paneel="' + pkPaneel.dataset.paneel + '"]');
            if (pkModel) kiesModel(pkModel); else toonPaneel(pkPaneel.dataset.paneel);
          }
          pk.click();
        }
      }
    } catch (e) {}
    plaatsPreview();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();